module.exports = __webpack_public_path__ + "static/media/hand-holding-water.021d6abb.svg";